<script lang="ts">
    import { mdiInformationOutline } from "@mdi/js"
    import Checkbox from "./Checkbox.svelte"
    import Icon from "./Icon.svelte"
    import Popover from "./Popover.svelte"
    import Richtext from "./Richtext.svelte"
    import { login } from "../../store"
    import { _ } from "svelte-i18n"
    export let texts: DocumentTemplateTexts
    export let inProgress: boolean
    export let inProgressPlaceholder: string
    export let placeholderHint: string
    export let textareaAutoHeight: any
    export let originalPreLetter: string = null
    export let showPreLetter = false
    export let type: "offer" | "orderConfirmation" = "offer"

    if (typeof texts?.preLetter !== "string" && originalPreLetter) {
        texts.preLetter = originalPreLetter
    }
</script>

<section>
    <div class="section-title">{$_("components.documentTemplate.textContent")}</div>

    <section class="bordered bordered-light">
        <section>
            <div class="section-title">{$_("components.documentTemplate.contact")}</div>
            {#if !location.pathname.includes("templates")}
                <div class="row" style="margin-bottom: 20px;">
                    <div class="col-sm-12 no-padding">
                        <Checkbox
                            bind:checked="{texts.contact.useLoggedInUserAsDefault}"
                            label="{$_('components.documentTemplate.useLoggedInUserAsContact')}"
                        />
                    </div>
                </div>
            {:else}
                <div class="row" style="margin-bottom: 20px;">
                    <div class="col-sm-12 no-padding">
                        {$_("components.documentTemplate.defaultContactPerson")}
                    </div>
                </div>
            {/if}
            {#if !texts?.contact?.useLoggedInUserAsDefault || location.pathname.includes("templates")}
                <div class="row">
                    <div class="col-sm-6 no-padding-left">
                        <label for="texts_contact_name">
                            {$_("components.documentTemplate.displayedContactPerson")}
                        </label>
                        <input
                            id="texts_contact_name"
                            type="text"
                            placeholder="{inProgress ? inProgressPlaceholder : 'Max Mustermann'}"
                            bind:value="{texts.contact.name}"
                            disabled="{inProgress}"
                            required
                        />
                        <label for="texts_contact_email">
                            {$_("components.documentTemplate.eMailOfContact")}
                        </label>
                        <input
                            id="texts_contact_email"
                            type="text"
                            placeholder="{inProgress
                                ? inProgressPlaceholder
                                : $_('components.documentTemplate.eMailOfContact')}"
                            bind:value="{texts.contact.email}"
                            disabled="{inProgress}"
                            required
                        />
                    </div>
                    <div class="col-sm-6 no-padding-right">
                        <label for="texts_contact_phone">
                            {$_("components.documentTemplate.telephoneOfContact")}
                        </label>
                        <input
                            id="texts_contact_phone"
                            type="tel"
                            placeholder="{inProgress ? inProgressPlaceholder : $_('general.telephone')}"
                            bind:value="{texts.contact.phone}"
                            disabled="{inProgress}"
                            required
                        />
                        <label for="texts_contact_webUrl">{$_("general.webAddress")}</label>
                        <input
                            id="texts_contact_webUrl"
                            type="url"
                            placeholder="{inProgress ? inProgressPlaceholder : 'https://...'}"
                            bind:value="{texts.contact.webUrl}"
                            disabled="{inProgress}"
                        />
                    </div>
                </div>
            {:else}
                {$_("components.documentTemplate.currentLoggedInUser")}
                {$login?.account.firstname}
                {$login?.account.lastname}
            {/if}
        </section>

        <section>
            <div class="section-title">{$_("components.documentTemplate.emailContent")}</div>

            <label for="emailSubject" class="layout layout-gap-xs">
                <span>{$_("components.documentTemplate.emailSubject")}</span>
                {#if placeholderHint}
                    <Popover>
                        <div class="pdfIntroInfoPopupTrigger" slot="trigger">
                            <Icon path="{mdiInformationOutline}" width="24" height="24" viewBox="0 0 24 24" />
                        </div>
                        <div>{@html placeholderHint}</div>
                    </Popover>
                {/if}
            </label>
            <div>
                <input
                    id="emailSubject"
                    type="text"
                    placeholder="{inProgress ? inProgressPlaceholder : $_('components.documentTemplate.subjectLine')}"
                    bind:value="{texts.emailSubject}"
                    disabled="{inProgress}"
                    required
                />
                {#if placeholderHint}
                    <div class="hint layout layout-gap-xs mb-sm">
                        <Icon path="{mdiInformationOutline}" width="24" height="24" viewBox="0 0 24 24" />
                        <div>{@html placeholderHint}</div>
                    </div>{/if}
            </div>
            <label for="emailBody">
                <span>{$_("components.documentTemplate.emailBody")}</span>
                {#if placeholderHint}
                    <Popover>
                        <div class="pdfIntroInfoPopupTrigger" slot="trigger">
                            <Icon path="{mdiInformationOutline}" width="24" height="24" viewBox="0 0 24 24" />
                        </div>
                        <div>{@html placeholderHint}</div>
                    </Popover>{/if}
            </label>
            <Richtext
                bind:value="{texts.emailBody}"
                disabled="{inProgress}"
                placeholder="{$_('components.documentTemplate.emailBodyPlaceholder')}"
            />
        </section>

        <section>
            <div class="section-title">{$_("components.documentTemplate.pdfContent")}</div>
            <div>
                <label for="texts_pdfIntro" class="layout layout-gap-xs">
                    <span>{$_("components.documentTemplate.introductionText")}</span>
                    {#if placeholderHint}
                        <Popover>
                            <div class="pdfIntroInfoPopupTrigger" slot="trigger">
                                <Icon path="{mdiInformationOutline}" width="24" height="24" viewBox="0 0 24 24" />
                            </div>
                            <div>{@html placeholderHint}</div>
                        </Popover>{/if}
                </label>
                <div>
                    <Richtext
                        bind:value="{texts.pdfIntro}"
                        disabled="{inProgress}"
                        placeholder="{$_('components.documentTemplate.introContent')}"
                    />
                </div>
            </div>
        </section>
        {#if showPreLetter}
            <section>
                <div>
                    <label for="texts_pdfIntro" class="layout layout-gap-xs">
                        <span>{$_("components.documentTemplate.coverLetter")}</span>
                        {#if originalPreLetter}
                            <Popover>
                                <div class="pdfIntroInfoPopupTrigger" slot="trigger">
                                    <Icon path="{mdiInformationOutline}" width="24" height="24" viewBox="0 0 24 24" />
                                </div>
                                <div>
                                    <b>{$_("components.documentTemplate.originalCoverLetter")}</b><br
                                    />{@html originalPreLetter}
                                </div>
                            </Popover>
                        {/if}
                    </label>
                    <div>
                        <Richtext bind:value="{texts.preLetter}" disabled="{inProgress}" placeholder="" />
                    </div>
                </div>
            </section>{/if}
        <section>
            <label for="texts_pdfIntro">
                <span>{$_("components.documentTemplate.closingNote")}</span>
                {#if placeholderHint}
                    <Popover>
                        <div class="pdfIntroInfoPopupTrigger" slot="trigger">
                            <Icon path="{mdiInformationOutline}" width="24" height="24" viewBox="0 0 24 24" />
                        </div>
                        <div>{@html placeholderHint}</div>
                    </Popover>{/if}
            </label>
            <Richtext
                bind:value="{texts.pdfOuttro}"
                disabled="{inProgress}"
                placeholder="{$_('components.documentTemplate.closingText')}"
            />
        </section>

        <section>
            <div class="section-title">
                {#if type === "offer"}
                    {$_("components.documentTemplate.deliveryTimeAndPaymentTerms")}
                {:else}
                    {$_("components.documentTemplate.paymentTerms")}
                {/if}
            </div>
            <div class="row">
                {#if type === "offer"}
                    <div class="col-sm-3 no-padding-left">
                        <label for="texts_deliveryTime"> {$_("components.documentTemplate.deliveryTime")}</label>
                        <input
                            id="texts_deliveryTime"
                            type="text"
                            placeholder="{inProgress
                                ? inProgressPlaceholder
                                : $_('components.documentTemplate.deliveryTime')}"
                            bind:value="{texts.deliveryTime}"
                            disabled="{inProgress}"
                            required
                        />
                    </div>
                {/if}
                <div class="col-sm-9 no-padding-right">
                    <label for="texts_paymentTerms">{$_("components.documentTemplate.paymentTerms")}</label>
                    <textarea
                        use:textareaAutoHeight
                        id="texts_paymentTerms"
                        class="standalone"
                        contenteditable
                        placeholder="{inProgress
                            ? inProgressPlaceholder
                            : $_('components.documentTemplate.paymentTermsDescription')}"
                        bind:value="{texts.paymentTerms}"
                        disabled="{inProgress}"
                        required
                    ></textarea>
                </div>
            </div>
        </section>
    </section>
</section>
